export const RECOIL_PREFIX = 'daily-react-';
